import { render, staticRenderFns } from "./ChatBotConversations.vue?vue&type=template&id=19270161&scoped=true&"
import script from "./ChatBotConversations.vue?vue&type=script&lang=js&"
export * from "./ChatBotConversations.vue?vue&type=script&lang=js&"
import style0 from "./ChatBotConversations.vue?vue&type=style&index=0&id=19270161&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19270161",
  null
  
)

export default component.exports